export default "__VITE_ASSET__2ed2d51d__"